<script setup lang="ts">
import * as pressable from "@zag-js/pressable";
import { normalizeProps, useMachine } from "@zag-js/vue";
import { ref, computed } from "vue";
import { SvgIcon } from "../";

interface Props {
	readMore?: string;
	readLess?: string;
	clamp?: number;
}

const { readMore = undefined, readLess = undefined, clamp = 5 } = defineProps<Props>();

const isOpen = ref<boolean>(false);

const [state, send] = useMachine(
	pressable.machine({
		id: (Math.random() + 1).toString(36).substring(7)
	})
);

const api = computed(() => pressable.connect(state.value, send, normalizeProps));
const clampClass = computed<string>(() => {
	const values: { [key: string]: string } = {
		"0": "",
		"1": "line-clamp-1",
		"2": "line-clamp-2",
		"3": "line-clamp-3",
		"4": "line-clamp-4",
		"5": "line-clamp-5",
		"6": "line-clamp-6"
	};

	return values[`${clamp}`] ?? "";
});
</script>

<template>
	<section class="text-sm">
		<p class="max-w-prose" :class="[!isOpen && readMore && readLess && clampClass]">
			<slot />
		</p>
		<button
			v-if="readMore && readLess && clamp"
			v-bind="api.pressableProps"
			class="outline-none mt-2 font-bold flex gap-x-2"
			@click="isOpen = !isOpen"
		>
			<span>
				{{ isOpen ? readLess : readMore }}
			</span>
			<SvgIcon name="chevron-down" class="duration-200 ease-in-out" :class="{ 'rotate-180': isOpen }" />
		</button>
	</section>
</template>
